export default function NuestroEquipo()
{
    return(
        <section className="page-section bg-primary text-white mb-0" id="nuestroequipo">
            <div className="container">
                <h2 className="page-section-heading text-center text-uppercase text-white">Nuestro Equipo</h2>
                <div className="row">
                    <img src="/assets/img/fabian_quiros.jpg" style={{marginTop:'20px'}} className="rounded-circle img-team img-responsive centerDiv" alt="Fabian Quirós Arce"/>
                    <h3 className="text-center">Fabian Quirós Arce</h3>
                    <p className="text-center">Bachillerato en Ciencias de la Computación.</p>
                    <p className="text-center">Master en Sistemas de Información Geográfica y Teledetección.</p>
                </div>
                <div className="text-center mt-4">
                    <a style={{margin:'5px'}} className="btn btn-xl btn-outline-light" target='_blank' rel="noopener noreferrer" href="assets/CV_es.pdf">
                        <i className="fas fa-download me-2"></i>
                        Descargar
                    </a>
                    <a style={{margin:'5px'}} className="btn btn-xl btn-outline-light" target='_blank' rel="noopener noreferrer" href="assets/CV_en.pdf">
                        <i className="fas fa-download me-2"></i>
                        Descargar
                    </a>
                </div>
            </div>
        </section>
    )
}